import axiosClient from "api/axiosClient";
import endpoints from "api/endpoints";

export const getAllProducts = () => {
  return axiosClient.post(endpoints.ALLPRODUCTS, {}, { 
    timeout: 60000 
  });
}
export const getProductsByCategoryId = (categoryId, { limit = 20, offset = 0 } = {}) => {
  return axiosClient.get(endpoints.PRODUCTS_BY_CATEGORY(categoryId), {
    params: { limit, offset },
  });
};
export const getProductById = async (id) => {
  return await axiosClient.get(endpoints.PRODUCT_BY_DETAILS_ID(id));
};

export const searchProductsAdvanced = (query, { categoryId, limit = 10, offset = 0 } = {}) => {
  return axiosClient.get(endpoints.SEARCH_ADVANCED, {
    params: {
      query,
      limit,
      offset,
      ...(categoryId && { categoryId }),
    },
    timeout: 60000,
  });
};
